import { Avatar } from 'antd'
import { BtnAnch } from 'components/elements/global'
import React from 'react'
import Utils from 'utils/helper'
import useChat from 'features/chat/hooks/useChat'
import { TChatHistoryList } from 'features/chat/types'
import { useReadChatMessageMutation } from 'features/chat/api'
import { formatChatTime } from 'features/chat/functions'
import useAuth from 'hooks/useAuth'

const ChatHistoryItem: React.FC<{ data?: TChatHistoryList }> = ({ data }) => {
 const { user } = useAuth()
 const { updateChatList } = useChat()
 const [readChatMessage] = useReadChatMessageMutation()

 const handleClick = () => {
  if (data?.lead_id) {
   //    readChatMessage({ chat_id: Number(data?.id) })
   updateChatList?.({
    id: data?.id,
    leadId: data?.lead_id as any,
    leadName: data?.name || '',
    leadEmail: data?.lead_email ?? '',
    unReadCount: data?.unreadCount ?? 0,
    minimized: false,
    transferowner: data?.transferowner,
   })
  }
 }

 // Determine status color class based on status or random/default for now if unconnected
 const statusClass = data?.status === 'busy' ? 'busy' : 'online'

 const isUnread = Number(data?.unreadCount ?? 0) > 0
 // Note: Assuming 'online' as default for visual matching of mock if data missing,
 // or we could use data?.status directly if backend provides 'online'/'offline'/'busy'.
 // The mock shows green (online) and yellow (busy?).

 const colorArray = [
  'greenColor',
  'reColor',
  'orangeColor',
  'pinkColor',
  'violotColor',
 ]

 // Calculate deterministic index based on lead_id or name
 const getColorIndex = (): number => {
  if (data?.lead_id) {
   return Number(data.lead_id) % colorArray.length
  }
  if (data?.name) {
   return (
    data.name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) %
    colorArray.length
   )
  }
  return 0
 }

 const avatarColorClass = colorArray[getColorIndex()]

 return (
  <div className="chat-history-wrapper">
   <div className={`chat-history-item ${isUnread ? 'unread-item' : ''}`}>
    <BtnAnch className="overlay-link" onClick={handleClick} />

    <div className="chat-avatar-wrapper">
     <Avatar
      className={`chat-avatar-img ${avatarColorClass}`}
      size={50}
      icon={Utils.shortName(data?.name || '')}
      src={null} // If we had an image URL it would go here
     />
     <span className={`status-indicator ${statusClass}`} />
    </div>

    <div className="chat-info-content">
     <div className="chat-name-row">
      <h4 className="chat-name">{data?.name}</h4>
      <span className="chat-time">
       {formatChatTime(data?.latest_message_time)}
      </span>
     </div>
     <div className="chat-message-row">
      <span className="chat-message-text">{data?.latest_message}</span>
      {isUnread && (
       <div className="chat-badge-col">
        <div className="unread-count-badge">
         {Number(data?.unreadCount ?? 0) > 99 ? '99+' : data?.unreadCount}
        </div>
       </div>
      )}
     </div>
    </div>
   </div>
   {data?.transferowner && (
    <div className="chat-transferowner mt-1">
     <i className="fas fa-user mb-1" />{' '}
     <span>
      {user?.account_type === 'Brokerage' ? 'Assigned To' : 'Assigned By'}{' '}
      {data?.transferowner}
     </span>
    </div>
   )}
  </div>
 )
}

export default ChatHistoryItem
